// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"344aee2e","885":"5ce0ce5d"}[chunkId] + ".chunk.js";
};